<template>
    <layouts-header></layouts-header>

    <cage-breadcrumb :title="title" :text="text" :text1="text1" />

    <coach-tabset></coach-tabset>

    <!-- Page Content -->
    <div class="content">
        <div class="container">
            <section>
                <div class="text-center mb-40">
                    <h3 class="mb-1">Payment</h3>
                    <p class="sub-title">Securely make your payment for the booking. Contact support for assistance.</p>
                </div>
                <div class="master-academy dull-whitesmoke-bg card mb-40">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-sm-flex justify-content-start align-items-center">
                            <a href="javascript:void(0);"><img class="corner-radius-10"
                                    src="@/assets/img/profiles/avatar-02.png" alt="User"></a>
                            <div class="info">
                                <div class="d-flex justify-content-start align-items-center mb-3">
                                    <span
                                        class="text-white dark-yellow-bg color-white me-2 d-flex justify-content-center align-items-center">4.5</span>
                                    <span>300 Reviews</span>
                                </div>
                                <h3 class="mb-2">Kevin Anderson</h3>
                                <p>Certified Badminton Coach with a deep understanding of the sport's strategies.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row checkout">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-7">
                        <div class="card booking-details">
                            <h3 class="border-bottom">Order Summary</h3>
                            <ul>
                                <li><i class="feather-calendar me-2"></i>27, April 2023</li>
                                <li><i class="feather-clock me-2"></i>05:00 PM to 07:00 PM</li>
                                <li><i class="feather-users me-2"></i>Total Hours : 3 Hrs</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-5">
                        <aside class="card payment-modes">
                            <h3 class="border-bottom">Checkout</h3>
                            <h6 class="mb-3">Select Payment Gateway</h6>
                            <div class="radio">
                                <div class="form-check form-check-inline mb-3">
                                    <input class="form-check-input default-check me-2" type="radio"
                                        name="inlineRadioOptions" id="inlineRadio1" value="Credit Card">
                                    <label class="form-check-label" for="inlineRadio1">Credit Card</label>
                                </div>
                                <div class="form-check form-check-inline mb-3">
                                    <input class="form-check-input default-check me-2" type="radio"
                                        name="inlineRadioOptions" id="inlineRadio2" value="Paypal">
                                    <label class="form-check-label" for="inlineRadio2">Paypal</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input default-check me-2" type="radio"
                                        name="inlineRadioOptions" id="inlineRadio3" value="Wallet">
                                    <label class="form-check-label" for="inlineRadio3">Wallet</label>
                                </div>
                            </div>
                            <hr>
                            <ul class="order-sub-total">
                                <li>
                                    <p>Sub total</p>
                                    <h6>$250</h6>
                                </li>
                                <li>
                                    <p>Additional Guest</p>
                                    <h6>$25</h6>
                                </li>
                                <li>
                                    <p>Service charge</p>
                                    <h6>$70</h6>
                                </li>
                            </ul>
                            <div class="order-total d-flex justify-content-between align-items-center">
                                <h5>Order Total</h5>
                                <h5>$450</h5>
                            </div>
                            <div class="form-check d-flex justify-content-start align-items-center policy">
                                <div class="d-inline-block">
                                    <input class="form-check-input" type="checkbox" value="" id="policy">
                                </div>
                                <label class="form-check-label" for="policy">By clicking 'Send Request', I agree to
                                    Dreamsport <router-link to="/pages/privacy-policy">Privacy Policy</router-link> and <router-link
                                        to="/pages/terms-condition">Terms of Use</router-link></label>
                            </div>
                            <div class="d-grid btn-block">
                                <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                    data-bs-target="#bookingconfirmModal">Proceed $200</button>
                            </div>
                        </aside>
                    </div>
                </div>
            </section>
        </div>
        <!-- Container -->
    </div>
    <!-- /Page Content -->

    <layout-footer></layout-footer>

    <coach-payment-modal></coach-payment-modal>
</template>

<script>
export default {
    data() {
        return {
            title: 'Book A Coach',
            text: 'Home',
            text1: 'Book A Coach',
        }
    },
}
</script>